export const SMList = [
  {
    id: 1,
    name: "Harsh Raj Dubey",
    designation: "Head Technology Team",
    fb: "https://www.facebook.com/HarshRajDubeyOfficial",
    instagram: "",
    linkedin: "https://www.linkedin.com/in/harshrajdubey/",
    pfp: "/assets/images/harsh1.png",
  },
  {
    id: 5,
    name: "Jatin Khubani",
    designation: "Head Design and Videography Team",
    fb: "https://www.facebook.com/profile.php?id=61561661712640",
    instagram: "",
    linkedin: "https://www.linkedin.com/in/jatin-khubani-a80456319/",
    pfp: "/assets/images/jatin1.png",
  },
  {
    id: 2,
    name: "Aayan Nawaz",
    designation: "Executive Head",
    fb: "https://www.facebook.com/aayan.nawaz.775694",
    instagram: ["frontend", "ui/ux", "design"],
    linkedin: "https://www.linkedin.com/in/aayan-nawaz/",
    pfp: "/assets/images/aayan1.png",
  },
  {
    id: 3,
    name: "Drashti Gala",
    designation: "Executive Head",
    fb: "https://www.facebook.com/profile.php?id=61565579494856",
    instagram: ["frontend", "ui/ux", "design"],
    linkedin: "https://www.linkedin.com/in/drashti-gala-aa02b9327/",
    pfp: "/assets/images/drashti1.png",
  },

  {
    id: 4,
    name: "Kshitij Reddy",
    designation: "Executive Head",
    fb: "https://www.facebook.com/profile.php?id=61564172623560",
    instagram: ["frontend", "ui/ux", "design"],
    linkedin: "https://www.linkedin.com/in/kshitijreddymokila/",
    pfp: "/assets/images/kshitij1.png",
  },

  {
    id: 6,
    name: "Rushil Sinha",
    designation: "Head Career Council",
    fb: "https://www.facebook.com/profile.php?id=61577309362558",
    instagram: "",
    linkedin: "https://www.linkedin.com/in/rushil-sinha-501373330/",
    pfp: "/assets/images/rushil1.png",
  },

  {
    id: 7,
    name: "Maitri Gupta",
    designation: "Head Mentorship Council",
    fb: "https://www.facebook.com/profile.php?id=61565089149152",
    instagram: ["frontend", "ui/ux", "design"],
    linkedin: "https://www.linkedin.com/in/maitri-gupta-bb2240313/",
    pfp: "/assets/images/maitri1.png",
  },
  {
    id: 8,
    name: "Sahil",
    designation: "Head Academics Council",
    fb: "https://www.facebook.com/profile.php?id=61565314240654",
    instagram: ["frontend", "ui/ux", "design"],
    linkedin: "https://www.linkedin.com/in/sahil-76453731b/",
    pfp: "/assets/images/sahil1.png",
  },
  {
    id: 9,
    name: "Sanskar",
    designation: "Head Engagement & Outreach Council",
    fb: "https://www.facebook.com/profile.php?id=61565351462891",
    instagram: ["frontend", "ui/ux", "design"],
    linkedin: "https://www.linkedin.com/in/sanskar-chaudhary-360a6b2ab/",
    pfp: "/assets/images/sanskar1.png",
  },
];
